<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useKidRoutes } from '@entities/customer'
import { useDisciplineInKid } from '@entities/customer'
import { useKidStore } from '@entities/customer'

import HeaderNavItem from './HeaderNavItem.vue'
import { useDisciplineLink } from './discipline-link.hook'

defineOptions({
  name: 'LinkDisciplineEla',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const text = 'ELA'

const kidStore = useKidStore()

const {
  isRouteDisciplineEla,
  homeEla,
} = useKidRoutes()

const { isDisciplineEla } = useDisciplineInKid()

const { discount, handleClick } = useDisciplineLink({
  discipline: Discipline.ELA,
  isDiscipline: isDisciplineEla,
  isRouteDiscipline: isRouteDisciplineEla,
  homeRoute: homeEla,
  trackName: 'discipline_ela',
  text,
})

</script>

<template>
  <HeaderNavItem
    :layout="layout"
    icon="book-open-reader"
    :label="text"
    :href="homeEla ?? undefined"
    :selected="isRouteDisciplineEla"
    :disabled="!kidStore.hasActiveKid"
    :discount="discount"
    @click="handleClick"
  />
</template>
